import React from "react";

import { ID } from "common/entities/IEntity";
import { IPanelProps, Panel } from "core/decorators/Panel";
import RefineCategory from "./category/RefineCategory";
import RefineCategoryPanelConfig from "./config/RefineCategoryPanelConfig";
import constants from "./constants";


@Panel({
	id: "refine-kb-category",
	configClass: RefineCategoryPanelConfig,
	pageParams: true
})
class RefineCategoryPanel extends React.Component<IPanelProps<RefineCategoryPanelConfig>> {

	public render() {

		const { config, pageParams } = this.props;

		if (!config.knowledgeBaseId) {
			return null;
		}

		const cp = pageParams[constants.PARAM_CATEGORY_IDS];

		const selected = cp && cp.split(',') || [];

		return (
			<RefineCategory
				onChange={this.onChangeCategories}
				selected={selected}
				knowledgeBaseId={config.knowledgeBaseId}
			/>
		);
	}

	private onChangeCategories = (ids: ID[]) => {
		this.props.actions.pushPageParam(constants.PARAM_CATEGORY_IDS, ids.join(','));
	}
}



// WEBPACK FOOTER //
// ./src/panels/kb/RefineCategory.panel.tsx